import React from 'react';
import Dialog from '@mui/material/Dialog';

import { useSnackbar } from '../../shared/context';
import { CreateTrainingDialog } from '../layout/training/CreateTrainingDialog';
import { EditTrainingDialog } from '../layout/training/EditTrainingDialog';
import { useDialog } from '../../shared/context';

export const TrainingDialog = ({ handleCancel, dialogData, fetchTrainingTable }) => {
  const { showSnackbar } = useSnackbar();
  const reprovedDocumentDialog = useDialog('trainingDialog');

  const handleView = () => {
    switch (dialogData.type) {
      case 'create':
        return (
          <CreateTrainingDialog
            showSnackbar={showSnackbar}
            handleCancel={handleCancel}
            dialogData={dialogData}
            fetchTrainingTable={fetchTrainingTable}
          />
        );

      default:
        return (
          <EditTrainingDialog
            showSnackbar={showSnackbar}
            handleCancel={handleCancel}
            dialogData={dialogData}
            fetchTrainingTable={fetchTrainingTable}
          />
        );
    }
  };

  return (
    <Dialog
      open={reprovedDocumentDialog.isDialogOpen()}
      onClose={reprovedDocumentDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
      fullWidth
    >
      {handleView()}
    </Dialog>
  );
};
